import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { Box, Tooltip } from '@mui/material'
import { useTranslation } from 'react-i18next'

import CustomTypography from '@/components/dataDisplay/CustomTypography'

type GroupsTabAvailableGroupsHeaderProps = {
  allGroupsSize: number
  filteredGroupsSize: number
  isFiltering: boolean
  totalCapacity: number
}

function formatCapacity(mw: number): string {
  return mw >= 10 ? mw.toFixed(1) : mw.toFixed(2)
}

function GroupsTabAvailableGroupsHeader({
  allGroupsSize,
  filteredGroupsSize,
  isFiltering,
  totalCapacity,
}: Readonly<GroupsTabAvailableGroupsHeaderProps>) {
  const { t } = useTranslation()

  const countDisplay = isFiltering
    ? t('bidding.bidding_cascading.groups_tab.header_count_filtered', {
        filtered: filteredGroupsSize,
        total: allGroupsSize,
      })
    : t('bidding.bidding_cascading.groups_tab.header_count', { count: allGroupsSize })

  return (
    <Box sx={{ alignItems: 'center', display: 'flex', flexGrow: 1, gap: 0.5 }}>
      <CustomTypography variant="subtitle2">{t('bidding.bidding_cascading.groups_tab.header')}</CustomTypography>
      <Tooltip title={t('bidding.bidding_cascading.groups_tab.unassigned_groups_info')}>
        <InfoOutlinedIcon
          sx={{
            fontSize: '1rem',
            color: 'text.secondary',
            cursor: 'help',
            '&:hover': { color: 'primary.main' },
          }}
        />
      </Tooltip>
      <CustomTypography color="text.secondary" variant="caption">
        {countDisplay}
      </CustomTypography>
      <CustomTypography color="text.secondary" variant="caption">
        •
      </CustomTypography>
      <CustomTypography color="text.secondary" variant="caption">
        {formatCapacity(totalCapacity)} MW
      </CustomTypography>
    </Box>
  )
}

export default GroupsTabAvailableGroupsHeader
